module.exports = __webpack_public_path__ + "static/contrast-1bec7b95bd5cd7bde9cb8cca5265f923.mp4";